import {GlobalState} from '@/store';
import {MutationTypes} from './types';

const QuestionnaireMutation = {
  [MutationTypes.QUESTIONNAIRE_FLAG_CONTENT_SAVE](state: GlobalState, flag: any) {
    state.questionFlagText = flag;
    return state;
  },
};
export default QuestionnaireMutation;
